export default function getFullName(...value) {
  return value
    .map(v => `${v || ''}`.trim())
    .filter(Boolean)
    .join(' ');
}
